"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inverseErrorStyles = exports.hasErrors = exports.inverseField = exports.field = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var polished_1 = require("polished");

var styled_components_1 = require("styled-components");

var interactive_1 = require("../interactive/");

var typography_1 = require("../typography");

exports.field = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  transition: ", ";\n  ", "\n  color: ", ";\n  line-height: revert;\n\n  &:focus {\n    outline: none;\n    ", "\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n    ", "\n  }\n\n  ::placeholder {\n    ", "\n    color: ", ";\n    line-height: revert;\n  }\n"], ["\n  background: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  transition: ", ";\n  ", "\n  color: ", ";\n  line-height: revert;\n\n  &:focus {\n    outline: none;\n    ", "\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n    ", "\n  }\n\n  ::placeholder {\n    ", "\n    color: ", ";\n    line-height: revert;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, (0, polished_1.rem)(1), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.LIGHT', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('MOTION.DEFAULT_TRANSITION', theme);
}, typography_1.body, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, interactive_1.focus, interactive_1.isDisabled, typography_1.body, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
});
exports.inverseField = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  background: transparent;\n  color: ", ";\n  border: ", " solid\n    ", ";\n\n  &:focus {\n    outline: none;\n    ", "\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"], ["\n  ", "\n  background: transparent;\n  color: ", ";\n  border: ", " solid\n    ", ";\n\n  &:focus {\n    outline: none;\n    ", "\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"])), exports.field, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, (0, polished_1.rem)(1), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
}, interactive_1.focusInverse, interactive_1.isDisabledInverse, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
});
exports.hasErrors = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  border: ", " solid\n    ", ";\n  box-shadow: 0 0 0 ", "\n    ", ";\n"], ["\n  border: ", " solid\n    ", ";\n  box-shadow: 0 0 0 ", "\n    ", ";\n"])), (0, polished_1.rem)(1), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ERROR', theme);
}, (0, polished_1.rem)(1), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ERROR', theme);
});
exports.inverseErrorStyles = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  border: ", " solid\n    ", ";\n  box-shadow: 0 0 0 ", "\n    ", ";\n"], ["\n  border: ", " solid\n    ", ";\n  box-shadow: 0 0 0 ", "\n    ", ";\n"])), (0, polished_1.rem)(1), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ERROR_INVERSE', theme);
}, (0, polished_1.rem)(1), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ERROR_INVERSE', theme);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;